module.exports = __webpack_public_path__ + "img/semioad-original-1920.1651f1ae.webp";